import { render } from "./CheckRadio.vue?vue&type=template&id=a8dea416"
import script from "./CheckRadio.vue?vue&type=script&lang=js"
export * from "./CheckRadio.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__